import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";
import { route } from "./types.ts";


export const getRoutes = defineQuery({
  input: z.object({
    bypassCache: z.boolean().optional()
  }).optional(),
  handler: async ({ db }) => {
    const { data, error } = await db
      .from("routes")
      .select("*")
    if (error) throw error;
    return data as route[];
  },
});